import VoltError from 'VoltError'
import { throwError, of } from 'rxjs'
import { mergeMap, catchError } from 'rxjs/operators'
import NagraPinApi from 'services/nagra/PinApi'

export default class PinApi extends NagraPinApi {
    constructor(config, otherApis = {}) {
        super(config, otherApis)
        this.gatewayApi = otherApis.gatewayApi
    }

    /**
     * Calls proper reset function according to a PIN type
     * @param {PinType} type - user's PIN type
     * @returns {Observable<Boolean>|Observable<VoltError>} returns true if resetting was successful
     */
    resetPin(type) {
        switch (type) {
            case PinApi.TYPE.ADULT:
                return this.gatewayApi.resetParentalPin()
            case PinApi.TYPE.CENSORSHIP:
                return this.gatewayApi.resetR21Pin()
            default:
                return throwError(
                    new VoltError(VoltError.codes.FEATURE_NOT_AVAILABLE, {
                        extraLog: 'There is no such PIN type',
                    })
                )
        }
    }

    /**
     * Checks if user has a PIN with a given type
     * @param {PinType} type - user's PIN type
     * @returns {Observable<Boolean>} returns true if user has PIN with required type
     */
    isPinExist(type) {
        return this.getPins().pipe(
            mergeMap((pins) => this._isPinWithTypeExist(pins, type)),
            catchError((error) => {
                if (error.code === VoltError.codes.USER_PIN_UNSET.code) {
                    return of(false)
                }
                return throwError(error)
            })
        )
    }
}
